import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78e25050")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EditObject = _resolveComponent("EditObject")

  return (_openBlock(), _createBlock("div", {
    class: "editor",
    ref: "editor",
    tabindex: "1",
    style: {
      'background-image':
        'url(' +
        _ctx.frameToResourceUrl(
          _ctx.frameWithObjects.frame,
          _ctx.frameWithObjects.edit.isBalloonOn
        ) +
        ')',
      'background-size': 'cover',
      height: `${_ctx.editorSize.height}px`,
    },
    onDrop: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args))),
    onDragover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args)))
  }, [
    _createVNode("div", {
      class: "object-layer noselect",
      onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.editStore.selectObject(undefined)), ["self"]))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.frameWithObjects.edit.items, (object, i) => {
        return (_openBlock(), _createBlock(_component_EditObject, {
          tabindex: i,
          key: i,
          object: object,
          editStore: _ctx.editStore,
          editorScale: _ctx.editorScale,
          editorSize: _ctx.editorSize,
          onMousedown: ($event: any) => (_ctx.editStore.selectObject(object)),
          onKeydown: _withKeys(($event: any) => {
          _ctx.editStore.deleteObject(object);
          _ctx.editor.focus();
        }, ["delete"]),
          isSelected: _ctx.editStore.state.selectedObject == object,
          editorNaturalSize: _ctx.naturalSize
        }, null, 8, ["tabindex", "object", "editStore", "editorScale", "editorSize", "onMousedown", "onKeydown", "isSelected", "editorNaturalSize"]))
      }), 128))
    ], 32)
  ], 36))
})